<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训设备总账明细</h3> -->
    <el-page-header @back="goBack" class="pageHeader" content="院系设备总账详情">
    </el-page-header>
    <div>
      <el-tag type="info" style="margin-bottom:16px;font-size:15px;font-weight:bold;">当前院系：{{$route.query.structure_name}}</el-tag>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业">
          <el-select v-model="formInline.major" clearable filterable placeholder="请选择专业">
            <el-option v-for="item in majors" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="device_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="device_num" label="入库数量" width="100">
        </custom-table-column>
        <!-- <custom-table-column  prop="remainder_quantity" label="库存数量" width="100">
        </custom-table-column> -->
        <custom-table-column prop="remainder_quantity" label="库存数量" width="100">
        </custom-table-column>
        <custom-table-column prop="device_price" label="设备价格（元）" width="150">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" width="220">
        </custom-table-column>
        <!-- <custom-table-column prop="province" label="入库人" width="150">
        </custom-table-column> -->
        <custom-table-column prop="created_at" label="入库日期" width="180">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="province" label="入库人" width="150">
        </custom-table-column> -->

        <!-- <custom-table-column prop="phone" label="入库人电话" width="120">
        </custom-table-column>
        <custom-table-column prop="email" label="入库人邮箱" width="180">
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="130">
          <template>
            <el-button @click="handlePath('/EquipmentScrap')" type="text" size="small">报废</el-button>
            <el-button @click="handlePath('/equipmentFixed')" type="text" size="small">维修</el-button>
            <el-button @click="handlePath('/equipmentMaintain')" type="text" size="small">维护</el-button>
            <el-button @click="handlePath('/EquipmentBorrowOut')" type="text" size="small">借出</el-button>
            <el-button @click="handlePath('/EquipmentBorrowBack')" type="text" size="small">清还</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="设备名称" prop="device_name">
          <el-input v-model="ruleForm.device_name" placeholder="请输入设备名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备数量" prop="device_num">
          <el-input v-model.number="ruleForm.device_num" placeholder="请输入设备数量" style="width:198px;"></el-input> 个
        </el-form-item>
        <el-form-item label="设备价格" prop="device_price">
          <el-input v-model.number="ruleForm.device_price" placeholder="请输入设备价格" style="width:198px;"></el-input> 元
        </el-form-item> -->

        <el-form-item label="设备名称" prop="device_no">
          <el-select v-model="ruleForm.device_no" style="width:216px;" filterable placeholder="请选择设备" @change="handleEqChange">
            <el-option v-for="item in eqs" :key="item.id" :label="item.device_name" :value="item.device_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="device_num" label-width="20px">
          <!-- <el-input v-model.number="ruleForm.device_num" placeholder="请输入设备数量" style="width:198px;"></el-input> 个 -->
          （库存数量：{{ruleForm.device_num}} / 价格：{{ruleForm.device_price}}元）
        </el-form-item>
        <el-form-item label="设备型号" prop="device_type">
          <el-input v-model="ruleForm.device_type" placeholder="请输入设备型号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="生产厂家" prop="device_factory">
          <el-input v-model="ruleForm.device_factory" placeholder="请输入生产厂家" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="总价" prop="device_amount">
          <el-input v-model="ruleForm.device_amount" placeholder="请输入总价" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="使用方向" prop="usewhere">
          <el-input v-model="ruleForm.usewhere" placeholder="请输入使用方向" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备状况" prop="device_status">
          <el-input v-model="ruleForm.device_status" placeholder="请输入设备状况" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="存放地址" prop="leave_place">
          <el-input v-model="ruleForm.leave_place" placeholder="请输入存放地址" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="保管人员" prop="put_man">
          <el-input v-model="ruleForm.put_man" placeholder="请输入保管人员" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="购置日期" prop="buy_date">
          <el-date-picker type="datetime" placeholder="选择购置日期" v-model="ruleForm.buy_date" style="width:216px;"></el-date-picker>
        </el-form-item>

        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {baseUrlt} from "../../api";
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        device_name: '',
        training_room: '',
        structure_1: '',
        major: '',
      },
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        device_no: '',
        device_name: '',
        device_num: 0,
        device_price: 0,
        device_type: '',
        device_factory: '',
        device_amount: '',
        usewhere: '',
        device_status: '',
        leave_place: '',
        put_man: '',
        buy_date: '',
      },
      eqs: [],
      majors: [],
      rules: {
        device_no: [{ required: true, message: '请选择设备名称', trigger: 'blur' }],
        device_type: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
        device_num: [
          { required: true, message: '设备数量不能为空' },
          { type: 'number', message: '设备数量必须为数字值' },
        ],
        device_price: [
          { required: true, message: '设备价格不能为空' },
          { type: 'number', message: '设备价格必须为数字值' },
        ],
        device_factory: [{ required: true, message: '请输入生产厂家', trigger: 'blur' }],
        usewhere: [{ required: true, message: '请输入使用方向', trigger: 'blur' }],
        device_status: [{ required: true, message: '请输入设备状况', trigger: 'blur' }],
        leave_place: [{ required: true, message: '请输入存放地址', trigger: 'blur' }],
        put_man: [{ required: true, message: '请输入保管人员', trigger: 'blur' }],
        buy_date: [{ required: true, message: '请选择购买时间', trigger: 'change' }],
        device_amount: [
          { required: true, message: '总价不能为空' },
          { type: 'number', message: '总价必须为数字值' },
        ],
      },
      exportUrl:`${baseUrlt}/api/devicetotal/listExport`,
    };
  },
  components: {},
  created() {
    // this.getEqs();
    this.formInline.structure_1 = this.$route.query.structure_name;
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.getMajor();
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    goBack() {
      history.back();
    },
    handleLogChange(e) {
      this.ruleForm.scrap_name = this.$until.getLabelName(this.scraps, 'isid', 'ismc', e);
    },
    async getEqs() {
      let res = await this.getDataList('getDeviceIntoList');
      this.eqs = res.data.data;
    },
    async getMajor() {
      let res = await this.$api.instance.getMajor({ structure_ids: this.$route.query.structure_ids });
      if (res.code == 0 && res.data) {
        this.majors = res.data;
      }
    },
    handlePath(path) {
      this.$router.push(path);
    },
    handleEqChange(val) {
      this.ruleForm.device_name = this.$until.getLabelName(this.eqs, 'device_no', 'device_name', val);
      this.ruleForm.device_num = this.$until.getLabelName(this.eqs, 'device_no', 'remainder_quantity', val);
      this.ruleForm.device_price = this.$until.getLabelName(this.eqs, 'device_no', 'device_price', val);
      console.log(this.ruleForm);
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceCount(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (params.buy_date) {
        let timee = params.buy_date.getTime() / 1000;
        params.buy_date = this.$until.getTimeStr(timee, '-');
      }
      let res = await this.$api.creat.createDeviceCount(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getDeviceCountList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
